import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../../assets/locales/English.json";
import pt from "../../assets/locales/Portuguese.json";

const savedLang =
  globalThis.window === undefined
    ? "en"
    : localStorage.getItem("lang") || "en";

i18n.use(initReactI18next).init({
  resources: {
    en,
    pt,
  },

  lng: savedLang,
  fallbackLng: "en",
  debug: true,

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;